import React from "react";
import styled from "styled-components";

// components
import PrimaryMenu from "./PrimaryMenu/index";
import TNPLogo from "core/SiteHeader/components/TNPLogo";
import HomeLink from "core/SiteHeader/components/HomeLink.js";
import User from "./User";

// data
import {
    HEIGHT,
    GAP,
    HAMBURGER_MENU_WIDTH,
    TNP_LOGO_WIDTH
} from "core/SiteHeader/Mobile/Layout/constants.js";

// styles
import { convertPxToRem } from "frontend/components/helpers";
const Row1Styled = styled.div`
    display: flex;
    gap: ${convertPxToRem(GAP)};
    height: ${convertPxToRem(HEIGHT)};
`;

const Col1Styled = styled.div`
    flex: 0 0 ${convertPxToRem(HAMBURGER_MENU_WIDTH)};
`;

const Col2Styled = styled.div`
    flex: 0 0 ${convertPxToRem(TNP_LOGO_WIDTH)};
`;

const Col3Styled = styled.div`
    flex: 1;
    display: flex;
    justify-content: flex-end;
`;

// component
export const Row1 = () => {
    return (
        <Row1Styled>
            <Col1Styled>
                <PrimaryMenu />
            </Col1Styled>
            <Col2Styled>
                <HomeLink>
                    <TNPLogo />
                </HomeLink>
            </Col2Styled>
            <Col3Styled>
                <User />
            </Col3Styled>
        </Row1Styled>
    );
};

export default Row1;
